import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { installUiSounds } from './audio/ui/uiSound';
import { installAudioUnlock } from './audio/unlock';
import './ui/styles.css';

installAudioUnlock();
installUiSounds();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
